import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BotApiToken, BotApiTokenScopes } from '@shared/index';
import { RouteShareService } from './route-share.service';
import { JwtPayload } from 'jwt-decode';
import { firstValueFrom } from 'rxjs';
import { removeFromArray } from '@reflact/tsutil';

export type ApiTokenInFrontend = (Omit<BotApiToken, 'token'> & JwtPayload)

@Injectable({
  providedIn: 'root'
})
export class BotApiTokenService {
  public apiTokens: ApiTokenInFrontend[] = [];

  constructor(public http: HttpClient, public rss: RouteShareService) {

  }

  public async loadApiTokens(): Promise<void> {
    const result = await this.getApiTokens(this.rss.botConfig._id);
    this.apiTokens = result;
  }

  private async getApiTokens(botId: string): Promise<ApiTokenInFrontend[]> {
    const result = await firstValueFrom(this.http.get<ApiTokenInFrontend[]>("/api/toolbox/apitoken/list/" + botId));
    return result;
  }

  public async createApiToken(tokenName: string, scopes: BotApiTokenScopes[], expiresIn: string | number): Promise<{ tokenObject: ApiTokenInFrontend, token: string }> {
    const reqBody: { token: { name: string, scopes: BotApiTokenScopes[] }, expiresIn: string | number } = {
      token: {
        name: tokenName,
        scopes: scopes
      },
      expiresIn
    };
    type resultType = { tokenObject: ApiTokenInFrontend, token: string }
    const createdToken = await firstValueFrom<resultType>(this.http.post<resultType>("/api/toolbox/apitoken/add/" + this.rss.botConfig._id,
      reqBody
    ));

    this.apiTokens.push(createdToken.tokenObject);
    return createdToken;
  }

  public async deleteUserInList(tokenId: string): Promise<void> {
    await firstValueFrom(this.http.delete("/api/toolbox/apitoken/revoke/" + this.rss.botConfig._id + "/" + tokenId));
    removeFromArray(this.apiTokens, ((u) => u._id == tokenId));
  }
}
